import { AllPlans as Plans } from '@/plans';
import { isDevEnv, safeJSONParse } from '@/utils';
import { BillingCycleEnum } from '../constants';
import _, { includes, filter, isObject, omit } from 'lodash';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import store from '@/store';
import { logger } from '@/utils/log';
import { getCartRequest } from '@/apis/cart';
import { $config } from '@/global-install/index';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import qs from 'query-string';
import { isEmptyVal } from '@/utils';

export function verifyPlanItemField() {
  const _verify = (obj) => {
    const requireField = [
      'type',
      'category',
      'plan_code',
      'cartInfo',
      'amount',
      'billing_cycle',
      'supportCoupon',
      'dependBasePlanTypeList',
      'typeNameKey',
    ];
    const missKey = requireField.find((k) => !Reflect.has(obj, k));
    if (missKey) {
      throw new Error(`${obj.type} miss key: ${missKey}`);
    }
    return obj;
  };

  return (plans) => {
    if (isDevEnv) {
      const _plansProxy = new Proxy(plans, {
        set(target, k, v) {
          if (!isNaN(Number(k, 10)) && v) {
            _verify(v);
          }
          return Reflect.set(target, k, v);
        },
      });
      return _plansProxy;
    }
    return plans;
  };
}

export function plansDataMapper(planMapJSON, subscriptions = []) {
  const _planMapFlat = verifyPlanItemField()([]);
  Plans.forEach((p) => {
    if (p.pre) {
      const res = p.pre(planMapJSON, this, subscriptions);
      if (res) {
        _planMapFlat.push(...res);
      }
    }
  });
  const list = _planMapFlat.map((item) => ({
    ...item,
    cycleValue: BillingCycleEnum[item.billing_cycle] || -1,
    isOnline: true,
  }));
  store.commit('setPlanMapFlatRaw', [...list]);
  return list;
}

export function loadSelectByPersist(persist) {
  return function (planMapFlat) {
    if (!persist) {
      return planMapFlat;
    }

    return planMapFlat.map((item) => {
      const planCode = item.plan_code;
      let trialInfo = persist[planCode]?.trialInfo
      let cartInfo = omit(persist[planCode], ['trialInfo']);

      // PRO INCREASE
      if (PLAN_PRICE_CHANGE_UTILS.isConsiderPriceChangeCase(planCode)) {
        const mappingPlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode);
        cartInfo = cartInfo ?? omit(persist[mappingPlanCode], ['trialInfo']);
      }
      const mapResultItem = {
        ...item,
        cartInfo: cartInfo || item.cartInfo,
      };
      if (trialInfo) {
        mapResultItem.trialCode = trialInfo.trialCode
        mapResultItem.trialDays = trialInfo.trialDays
        mapResultItem.campaignCode = trialInfo.campaignCode
        mapResultItem.isOnlineFreeTrial = trialInfo.isOnlineFreeTrial
      }

      return mapResultItem;
    });
  };
}

export function filterCapacity(capacityList = {}) {
  return (planMapFlat = []) => {
    return filter(planMapFlat, (p) => {
      return capacityList[p.type] && !p.isPPA ? includes(capacityList[p.type], p.capacity) : p;
    });
  };
}

export function buildShoppingCartWithPersist(allPlans, persist) {
  if (!persist) {
    logger.log('buildShoppingCartWithPersist: error', 'cache is empty');
    return null;
  }
  const nextPlans = loadSelectByPersist(persist)(allPlans);
  const selectedPlans = nextPlans.filter((item) => item.cartInfo?.selected_number > 0);
  if (!selectedPlans.length) {
    logger.log('buildShoppingCartWithPersist: error', 'cache is invalid');
    return null;
  }
  logger.log('buildShoppingCartWithPersist: selectedPlans:', selectedPlans);
  return nextPlans;
}

const compareVisitLinkWithCache = (originalLink) => {
  try {
    if (isEmptyVal(originalLink)) return true;

    const compareParams = ["plan", "from", "from_sub"];
    const originalParams = _.pick(qs.parse(new URL(originalLink).search), compareParams);
    const currentParams = _.pick(qs.parse(location.search), compareParams);

    return _.isEqual(originalParams, currentParams);
  } catch (e) {
    return true;
  }
}

export const loadByShoppingCart = async (planList) => {
  const isSelectedPlan = planList.some((item) => item?.cartInfo?.selected_number > 0);
  if (!persistCartConstant?.enablePersistShoppingBag || $config('persist_cart') !== 'true' || isSelectedPlan) {
    return planList;
  }

  try {
    const res = await getCartRequest();
    const cartInfo = safeJSONParse(res?.result?.cartInfo);
    const persist = cartInfo?.persist;
    const healthcareInfo = cartInfo?.extension?.healthcareInfo
    if (!isObject(persist)) {
      return planList;
    }

    // fix with not match link(previous link with current link)
    if (!compareVisitLinkWithCache(cartInfo?.link)) {
      logger.info("[persist-cart]: current link not match original cache link!!!");
      return planList;
    }

    if(healthcareInfo) {
      store.commit('updateHealthcare', healthcareInfo);
    }

    return loadSelectByPersist(persist)(planList);
  } catch (error) {
    return planList;
  }
};
